import { useContext, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router';
import { motion, Transition, Variants } from 'motion/react';
import { uiContext } from '@/providers/UIContextProvider';
import PageRoutes from './PageRoutes';

const pageVariants: Variants = {
  initial: {
    opacity: 0,
    overflow: 'hidden',
    // scaleY: 0,
  },
  in: {
    opacity: 1,
    overflow: 'visible',
    // scaleY: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition: Transition = {
  type: 'tween',
  ease: 'easeInOut',
  delay: 0.1,
  duration: 0.5,
};

export const AnimationLayout = () => {
  const { pathname } = useLocation();
  const { setHeaderVisible } = useContext(uiContext);
  const ref = useRef<HTMLDivElement>(null);

  // when page change we scroll to top
  useEffect(() => {
    ref.current?.scrollTo(0, 0);

    // base on pathname, we display or not the header + navigation
    const page = Object.values(PageRoutes)
      .filter((page) => page.path !== '/')
      .find((page) => pathname.includes(page.path));
    if (page) setHeaderVisible(page.showHeader);
  }, [pathname, setHeaderVisible]);

  return (
    <motion.div
      ref={ref}
      key={pathname}
      initial="initial"
      animate="in"
      variants={pageVariants}
      transition={pageTransition}
      className="flex-grow"
    >
      <Outlet />
    </motion.div>
  );
};
